import React from 'react'
import classNames from 'classnames'

import type { Image } from 'types'
import style from './style.module.css'

type Props = Image & {
  index: number
  activeIndex: number
  setActiveIndex: (index: number) => void
}

function ImageGalleryThumbnail({
  sizes,
  alt,
  index,
  activeIndex,
  setActiveIndex,
}: Props) {
  const isActive = index === activeIndex

  function handleClick() {
    setActiveIndex(index)
  }

  return (
    <button
      className={classNames(style.wrapper, { [style.isActive]: isActive })}
      onClick={handleClick}
    >
      <img alt={alt} src={sizes.small} />
    </button>
  )
}

export default ImageGalleryThumbnail
